module.exports = __webpack_public_path__ + "static/img/IMG_20170305_142504.b18c2af2.jpg";